/**
 * Created by Administrator on 2018/6/19.
 */
export default {
  state: {
    username: '',
    isLogin: false,
    type:'',
  },
  getters: {
    username(state){
      if (!state.isLogin) {
        state.isLogin=sessionStorage.getItem('isLogin');
        state.username=sessionStorage.getItem('username');
      }
      return state.username
    },
    isLogin(state){
      if (!state.isLogin) {
        state.isLogin=sessionStorage.getItem('isLogin');
        state.username=sessionStorage.getItem('username');
      }
      return state.isLogin
    },
    type(state){
        state.type=sessionStorage.getItem('type');
      return state.type
    },

  },
  mutations: {
    user_login(state,username){
      sessionStorage.setItem("username", username);
      sessionStorage.setItem("isLogin",true);
      state.username=username;
      state.isLogin=true
    },
    user_type(state,type){
      sessionStorage.setItem("type", type);
      state.type=type
    },
    user_logout(state){
      sessionStorage.removeItem("username");
      sessionStorage.removeItem("isLogin");
      state.username='';
      state.isLogin=false;
    },
  },
  actions: {
    user_login(context,username){
      context.commit('user_login',username);
    },
    user_type(context,type){
      context.commit('user_type',type);
    },
    user_logout(context){
      context.commit('user_logout');
    },
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/webuser.js